if (!customElements.get("iyrs-localization")) {
  customElements.define(
    "iyrs-localization",
    class IyrsLocalization extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector("dialog");
        this.trigger = this.querySelector("[data-iyrs-locale-open]");
        this.closeButton = this.querySelector("[data-iyrs-locale-close]");
        if (!this.dialog || !this.trigger) return;

        this.trigger.addEventListener("click", () => this.dialog.showModal());
        this.closeButton?.addEventListener("click", () => this.dialog.close());
        this.dialog.addEventListener("click", (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener("close", () => this.trigger.focus());
      }
    }
  );
}
